import React from 'react';
import LandingPage from './components/LandingPage';

const App = () => <LandingPage />;

export default App;
